<template>
	<b-modal ref="event-resolve-modal" title="Resolve Event" v-model="show" v-if="rec">

		<div class="message" v-bind:class="{'show': rec.resolution.key}">
			<p v-if="rec.resolution.label">{{rec.resolution.label}}</p>
		</div>
		<div class="message" v-bind:class="{'show': rec.result.key}">
			<p v-if="rec.result.label">{{rec.result.label}}</p>
		</div>
		<div class="message" v-bind:class="{'show': rec.exit.key}">
			<p v-if="rec.exit.label">{{rec.exit.label}}</p>
		</div>

		<div v-if="rec.status == 'pending'">
			<b-row align-h="center">
				<b-col cols="6">
					<div class="form-group">
						<button class="btn btn-primary form-control" @click.stop="clearAlert(key)">Log and Clear</button>
					</div>
					<div v-if="!rec.resolution.key ">
						<transition name="fade">
							<div v-if="rec.type == 'entry'" class="form-group">
								<button class="btn btn-primary form-control" @click.stop="buzzAsset(key)">Buzz Asset
								</button>
							</div>
						</transition>
						<transition name="fade">
							<div v-if="rec.type == 'man-down' || rec.type == 'fall'" class="form-group">
								<button class="btn btn-primary form-control" @click.stop="notifySecurity(key)">Notify
									Security
								</button>
							</div>
						</transition>
					</div>

				</b-col>
			</b-row>
		</div>

		<div slot="modal-footer">
			<button type="button" class="btn btn-secondary" @click="show=false">Close</button>
		</div>

	</b-modal>
</template>

<script>

	export default {
		name: 'EventResolve',
		data() {
			return {
				show: false,
				//rec: null,
				key: null,
				resolution: null
			}
		},
		computed: {
			alert: {
				get() {return this.$store.state.alert },
				set(value) {
					this.$store.commit('set_alert', value);
				}
			},
			end_time() { return this.$config.end_time},
			workers() { return this.$store.state.workers; },
			worker_types() { return this.$config.worker_types },
			rec: {
				get() { return this.key ? this.$store.state.alert[this.key] : null },
			//	set(value) { return value }
			},
			time() { return this.$store.state.time },
			day() { return this.$store.state.day},
			clock() { return this.$store.state.clock },
			watcher() { return this.$store.state.watcher }
		},
		watch: {
			rec: {
				handler() {

				},
				deep: true
			}
		},
		methods: {
			showModal(key) {
				this.show = true;
				this.key = key;
				//this.rec = this.alert[key];

			},
			clearAlert(key) {
				let worker = this.workers[this.rec.worker.id];
				if (worker.status == 'injury') worker.status = 'at-zone';
				this.$store.commit('clear_alert', {key: key, type: 'clear', day: this.day, time: this.time, label: "Issue was Cleared at "+ this.$datetime.time(this.time) + ".", type_label: 'Log and Clear'});
			},
			buzzAsset(key) {
				//let workers = $.extend(true, {}, this.workers);
				let worker = this.workers[this.rec.worker.id];

				let log = this.$finder.all({type: 'entry'}, this.watcher[this.rec.day][worker.id]);
				let zone = this.$zone.get(log[1].zone_id);

				log = log.reverse();
				if (log[1] != undefined) worker.override = zone.type
				else worker.override = 'planning';

				//if (worker.status == 'injury') worker.status = 'at-zone';

				this.$store.commit('alert_resolution', {key: key, type: 'buzz', day: this.day, time: this.time, label: "Asset tag audio and light has been activated.", type_label: 'Buzz Asset'});


			},
			notifySecurity(key) {

				let worker = this.workers[this.rec.worker.id];
				worker.override = 'planning';

				//if (worker.status == 'injury') worker.status = 'at-zone';

				let label = ( this.rec.type == 'man-down' ?  'Security has arrived at location.' : "EMTs have been dispatched, asset is receiving medical care." );

				this.$store.commit('alert_resolution', {key: key, type: 'notify_security', day: this.day, time: this.time, label: label, type_label: 'Notify Security'});
			}

		}
	}
</script>
<style lang="scss" rel="stylesheet/scss">
	.message {
		opacity: 0;
		&.show {
			opacity: 1;
			transition:  opacity 1s ease;;
		}
	}
</style>
